import { __cms_DocumentReady, __USE_JAVASCRIPT_CONSOLE_LOG } from '../../neal_cms_includes/document_ready/document_ready_class.js'; //quiet

document.addEventListener('DOMContentLoaded', function () {
    if (__USE_JAVASCRIPT_CONSOLE_LOG === 'true') {
        console.log('called : (Frontend Base)');
    }
    let oFrontendBase = new frontendBase();
    oFrontendBase.init();
    // Waits for the document to load then shows the body
    document.getElementsByClassName('grid-manager-body-container')[0].style.display = 'block';
    document.getElementById('cms_frontend_footer').style.display = 'block';
});

/*----------------------------------------------------------------------
    Class:frontendBase
----------------------------------------------------------------------*/
class frontendBase {
    /*----------------------------------------------------------------------
        Method: init
    ----------------------------------------------------------------------*/
    init() {
        __cms_DocumentReady.init();
        this.loadJavascriptFiles();
    }

    /*----------------------------------------------------------------------
        Method: loadJavascriptFiles
    ----------------------------------------------------------------------*/
    loadJavascriptFiles() {
        /*
            Simple Animation
        */
        const oLoadSimpleAnimation_dataset = document.getElementById('frontend-load-javascript-files').dataset;
        const loadScrollAnimation = oLoadSimpleAnimation_dataset.loadScrollAnimation;
        function load_Simple_animation() {
            let scriptFile = document.createElement('script');
            scriptFile.setAttribute('src', document.getElementById('SiteURL').value + 'neal_cms/neal_cms_includes/simple_animation/simple_animation_css_generator_min.js');
            document.head.appendChild(scriptFile);
        }

        if (loadScrollAnimation !== undefined) {
            load_Simple_animation();
        }

        /*
            Parallax
        */
        function load_Simple_parallax() {
            const oParallaxInstances = document.querySelectorAll('[data-parallax]');

            if (oParallaxInstances !== null) {
                let scriptFile = document.createElement('script');
                // scriptFile.setAttribute('src', document.getElementById('SiteURL').value + 'neal_cms/neal_cms_includes/parallax/parallax_min.js?' + Math.random());
                scriptFile.setAttribute('src', document.getElementById('SiteURL').value + 'neal_cms/neal_cms_includes/parallax/parallax.js?' + Math.random());
                document.head.appendChild(scriptFile);
            }
        }
        load_Simple_parallax();

        /*
            Paypal subscriptions
        */
        // function load_Paypal_subscriptions() {
        //     const oPaypalSubscriptionsInstance = document.querySelector('[data-paypal-subscriptions-instance]');
        //     const oPaypalFrontendAdministrationInstance = document.querySelector('[data-paypal-frontend-administration-instance]');

        //     if (oPaypalSubscriptionsInstance !== null || oPaypalFrontendAdministrationInstance !== null) {
        //         let scriptFile = document.createElement('script');
        //         scriptFile.setAttribute(
        //             'src',
        //             document.getElementById('SiteURL').value + 'neal_cms/neal_cms_includes/bootstrap_grid_manager/grid_dependancys/content_type_classes_user_page/Paypal/PaypalSubscriptions/paypal_subscriptions_min.js?' + Math.random()
        //         );
        //         scriptFile.setAttribute('defer', 'defer');
        //         document.head.appendChild(scriptFile);
        //     }
        // }
        // load_Paypal_subscriptions();

        /*
            Stripe Payment Gateway
        */

        // async function loadStripe() {
        //     return new Promise((resolve, reject) => {
        //         let stripeFile = document.createElement('script');
        //         stripeFile.setAttribute('src', 'https://js.stripe.com/v3/');
        //         stripeFile.addEventListener('load', resolve);
        //         stripeFile.addEventListener('error', reject);
        //         document.head.appendChild(stripeFile);
        //     });
        // }

        // async function main() {
        //     try {
        //         await loadStripe();
        //         // Loads CMS Stripe Custom script
        //         let scriptFile = document.createElement('script');
        //         scriptFile.setAttribute(
        //             'src',
        //             document.getElementById('SiteURL').value + 'neal_cms/neal_cms_includes/bootstrap_grid_manager/grid_dependancys/content_type_classes_user_page/StripePaymentGateway/StripePaymentGateway.js?' + Math.random()
        //         );
        //         scriptFile.setAttribute('defer', 'defer');
        //         document.head.appendChild(scriptFile);
        //     } catch (error) {
        //         console.error('Failed to load Stripe script:', error);
        //     }
        // }

        // function load_StripePaymentGateway() {
        //     const oStripePaymentGatewayInstance = document.querySelector('[data-stripe-payment-gateway-instance]');
        //     if (oStripePaymentGatewayInstance !== null) {
        //         main();
        //     }
        // }
        // load_StripePaymentGateway();
    }
}
